import PropTypes from "prop-types";
import { useRouter } from "next/router";
import Iconify from "../../iconify";
import IconCode from "@/src/lib/iconCode";
import { StyledDotIcon, StyledIcon, StyledItem } from "./navStyles";

export default function NavItem({
    navItems,
    open,
    depth,
    active,
    config,
    externalLink,
    ...other
}) {
    const { title, path, icon, info, children, disabled, caption, routePath } =
        navItems;
    const router = useRouter();
    const subItem = depth !== 1;

    const handleOnClickEvent = (e) => {
        e.preventDefault();
        if (!disabled) {
            router.push(`/locate-us/${routePath}`);
        }
    };

    const renderContent = (
        <StyledItem
            active={active}
            depth={depth}
            config={config}
            disabled={disabled}
            {...other}
        >
            {/* Icon */}
            {icon && <StyledIcon size={config.iconSize}>{icon}</StyledIcon>}

            {/* Title + Caption */}
            <div className="ml-2 flex-1">
                <span
                    className={`block text-sm capitalize truncate ${
                        active ? "font-bold text-gray-900" : "text-gray-700"
                    }`}
                >
                    {title}
                </span>
                {caption && (
                    <span className="block text-xs text-gray-400 truncate">
                        {caption}
                    </span>
                )}
            </div>

            {/* Info */}
            {info && <div className="ml-2 leading-none">{info}</div>}

            {/* Expand / Collapse */}
            {!!children && (
                <Iconify
                    width={16}
                    icon={open ? IconCode?.downArrow : IconCode?.upArrow}
                    className={`shrink-0 ${subItem ? "ml-2" : "ml-2 pr-2"}`}
                />
            )}
        </StyledItem>
    );

    if (externalLink) {
        return (
            <a
                href={path}
                target="_blank"
                rel="noopener noreferrer"
                className={`${disabled ? "cursor-not-allowed" : ""}`}
            >
                {renderContent}
            </a>
        );
    }

    if (children) {
        return renderContent;
    }

    return (
        <a
            href={path}
            onClick={handleOnClickEvent}
            className={`${disabled ? "cursor-not-allowed" : ""}`}
        >
            {renderContent}
        </a>
    );
}

NavItem.propTypes = {
    active: PropTypes.bool,
    config: PropTypes.object,
    depth: PropTypes.number,
    externalLink: PropTypes.bool,
    navItems: PropTypes.object,
    open: PropTypes.bool,
};
